<template>
  <div>
    <el-row
      type="flex"
      justify="space-between"
      class="item pb-20"
    >
      <span class="item-property">
        {{ $t("profile.tips-today") }}
      </span>
      <span class="item-value">
        {{
          (balance.paidToday / 100).toLocaleString($localeString, {
            style: "currency",
            currency: balance.currency,
          })
        }}
      </span>
    </el-row>
    <el-row
      type="flex"
      justify="space-between"
      class="item pt-20 pb-20"
    >
      <span class="item-property">
        {{ $t("profile.tips-last-week") }}
      </span>
      <span class="item-value">
        {{
          (balance.paidWeekly / 100).toLocaleString($localeString, {
            style: "currency",
            currency: balance.currency,
          })
        }}
      </span>
    </el-row>
    <el-row
      type="flex"
      justify="space-between"
      class="item pt-20 pb-20"
    >
      <span class="item-property">
        {{ $t("profile.balance-of-account") }}
      </span>
      <span class="item-value">
        {{
          (balance.available / 100).toLocaleString($localeString, {
            style: "currency",
            currency: balance.currency,
          })
        }}
      </span>
    </el-row>
    <el-row
      type="flex"
      justify="space-between"
      class="item pt-20 pb-20"
    >
      <span class="item-property">
        {{ $t("profile.transfer-balance") }}
      </span>
      <span class="item-value">
        {{
          (balance.reconcileAvailable / 100).toLocaleString($localeString, {
            style: "currency",
            currency: balance.currency,
          })
        }}
      </span>
    </el-row>
    <el-row
      type="flex"
      justify="space-between"
      class="item pt-20 pb-20"
    >
      <span class="item-property">
        {{ $t("re-conciliation.reconciled") }}
      </span>
      <span class="item-value">
        {{
          (balance.reconciled / 100).toLocaleString($localeString, {
            style: "currency",
            currency: balance.currency,
          })
        }}
      </span>
    </el-row>
    <el-row
      type="flex"
      justify="space-between"
      class="item pt-20 pb-20"
    >
      <span class="item-property">
        {{ $t("re-conciliation.inTransition") }}
      </span>
      <span class="item-value">
        {{
          (balance.inTransition / 100).toLocaleString($localeString, {
            style: "currency",
            currency: balance.currency,
          })
        }}
      </span>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "BalanceData",
  props: {
    balance: {
      type: Object,
      default: () => {
        return {
          paidToday: 0,
          paidWeekly: 0,
          available: 0,
          reconcileAvailable: 0,
          reconciled: 0,
          inTransition: 0,
          currency: 'EUR',
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.items {
  .item {
    border-bottom: 1px solid #e5e5e5;

    &-property {
      font-family: "Raleway Regular", serif;
      font-size: 16px;
      margin-right: 10px;
    }

    &-value {
      font-family: "Raleway Bold", serif;
      font-size: 16px;
    }
  }
}
</style>
